import React, { useEffect, useRef, useContext, useState } from "react";
import classes from "./Home.module.css";
import Header from "../../components/Header/Header";
import Services from "../../components/Services/Services";
import Introduction from "../../components/Introduction/Introduction";
import { useLocation, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import PrimaryBanner from "../../components/PrimaryBanner/PrimaryBanner";
import Introduction02 from "../../components/Introduction02/Introduction02";
import InstagramFeed from "../../components/InstagramFeed/InstagramFeed";
import Contacts from "../../components/Contacts/Contacts";
import FooterInfo from "../../components/FooterInfo/FooterInfo";
import Booking from "../../components/Booking/Booking";
import { NAIL_SHOP_INFO } from "../../utils/Const";
import useCheckIsMobile from "../../hook/useCheckIsMobile";
import RemoteConfig from "../../services/RemoteConfig";
import AuthContext from "../../store/auth-context";
import CustomerFeedback from "../../components/CustomerFeedback/CustomerFeedback";
import BackToTop from "../../components/BackToTop/BackToTop";
import FloatingButton from "../../components/FloatingButton/FloatingButton";
import { images } from "../../assets/img";

const DISCOUNT_POSTER_SESSION_KEY = "hasShownDiscountPoster";

function DiscountPosterPopup() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    let hasShownPoster = false;

    try {
      hasShownPoster = sessionStorage.getItem(DISCOUNT_POSTER_SESSION_KEY) === "true";
      if (!hasShownPoster) {
        sessionStorage.setItem(DISCOUNT_POSTER_SESSION_KEY, "true");
      }
    } catch {
      // Keep the site usable if the browser blocks session storage.
    }

    if (!hasShownPoster) setShowPopup(true);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    if (!showPopup) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") setShowPopup(false);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showPopup]);

  return (
    <>
      {showPopup && (
        <div className={classes.overlay} onClick={closePopup}>
          <div
            className={classes.popup}
            role="dialog"
            aria-modal="true"
            aria-label="T Nail Spa discount poster"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              className={classes.closeButton}
              type="button"
              aria-label="Close discount poster"
              onClick={closePopup}
            >
              <svg className={classes.closeIcon} viewBox="0 0 24 24" aria-hidden="true">
                <path d="M6 6l12 12M18 6 6 18" />
              </svg>
            </button>
            <img src={images.discountPoster} alt="T Nail Spa 20% discount poster" />
          </div>
        </div>
      )}
    </>
  );
}

const Home = () => {
  const location = useLocation();
  const { state } = location || {};
  const { isFocusServices, focusServices } = state || {};
  const serviceRef = useRef(null);
  const introductionRef = useRef(null);
  const contactsRef = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const isMobile = useCheckIsMobile();
  const isPopupShown = useRef(false);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch(
          `https://api.imgur.com/3/album/tk-nails-EEcKRZN`,
          {
            method: "GET",
            // headers: {
            //   Authorization: `Client-ID ecc939fbe1a915e`,
            // },
          }
        );


        if (!response.ok) {
          const errorDetails = await response.json();
          console.error("Error fetching Imgur album images:", errorDetails);
          throw new Error(`Request failed with status ${response.status}`);
        }

        const data = await response.json();

        // setImages(data.data); // `data` contains the array of image objects
      } catch (error) {
        console.error("Error fetching Imgur album images:", error);
      }
    };

    // fetchImages();
  }, []);

  useEffect(() => {
    if (focusServices) {
      setTimeout(() => {
        let sectionRef = null;
        switch (focusServices) {
          case "contacts":
            sectionRef = contactsRef;
            break;

          default:
            sectionRef = contactsRef;
            break;
        }
        sectionRef?.current?.scrollIntoView({ behavior: "smooth" });
        window.history.replaceState({}, document.title); // Clear the  state
      }, 500);
    }
    if (searchParams.get("booking")) {
      // Ex: http://localhost:3000/?booking=true
      //TODO: Replace serviceRef with bookingRef
      serviceRef?.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [focusServices]);

  const renderTopSeparatorMobile = () => {
    if (!isMobile) return null;

    return (
      <div className={classes.topSeparator}>
        <a className={classes.bookNowA} href={`tel:${NAIL_SHOP_INFO.tel}`}>
          {`PHONE: ${NAIL_SHOP_INFO.phone}`}
        </a>
      </div>
    );
  };

  return (
    <div className={classes.helloworld}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{NAIL_SHOP_INFO.name}</title>
        <meta name="service-details" content="Service description" />
        <meta name="description" content="Best Nail Bar" />
      </Helmet>
      {renderTopSeparatorMobile()}
      <Header selected={"home"} />
      <PrimaryBanner />
      <Services serviceRef={serviceRef} />
      <Introduction introductionRef={introductionRef} />
      <CustomerFeedback/>
      <Contacts contactsRef={contactsRef} />
      <FooterInfo />
      <FloatingButton />
      <DiscountPosterPopup />
    </div>
  );
};
export default Home;
